// extracted by mini-css-extract-plugin
module.exports = {"container":"noteForm_container__2DpHQ","input":"noteForm_input__1424n","formLabel":"noteForm_formLabel__2dj-I","formControl":"noteForm_formControl__1nrBB"};